/*
Code for the Home Page
*/

import { useState } from "react";
import ReactCardFlip from "react-card-flip";
import { GiRapidshareArrow } from "react-icons/gi";
import { TbDatabaseSearch } from "react-icons/tb";
import { PiScalesBold } from "react-icons/pi";
import { ImStatsDots } from "react-icons/im";
import { MdComputer } from "react-icons/md";
import { Header } from "./Header";
import { Footer } from "./Footer";
import Quotes from "./Quotes";
import linalg from "./images/mdi_matrix.jpg";
import ControlledCarousel from "./Carousel";

function Home() {
  const [isFlipped1, setIsFlipped1] = useState(false);
  const [isFlipped2, setIsFlipped2] = useState(false);
  const [isFlipped3, setIsFlipped3] = useState(false);
  const [isFlipped4, setIsFlipped4] = useState(false);
  const [isFlipped5, setIsFlipped5] = useState(false);

  const flipCard = (num) => {
    if (num === 1) {
      setIsFlipped1(!isFlipped1);
    } else if (num === 2) {
      setIsFlipped2(!isFlipped2);
    } else if (num === 3) {
      setIsFlipped3(!isFlipped3);
    } else if (num === 4) {
      setIsFlipped4(!isFlipped4);
    } else {
      setIsFlipped5(!isFlipped5);
    }
  };
  return (
    <div>
      <Header />
      <ControlledCarousel />
      <default />
      <div>
        <div className="decor-bar">
          <h2 className="home-title"> What is Data Science at Scripps?</h2>
        </div>
        <div className="space2" />
        <div className="about_text">
          <p className="about_text">
            Data science is a multidisciplinary field that utilizes scientific
            methods, algorithms, and systems to extract insight from structured
            and unstructured data. Data scientists analyze datasets to uncover
            patterns, trends, and correlations, ultimately informing
            decision-making processes across domains such as government,
            healthcare, and finance.
          </p>
          <p className="about_text">
            The Data Science Minor at Scripps College is designed to support
            students in existing Majors who have interests in developing
            computational capability, data skills, inferential reasoning from
            large repositories of data, and ethical reasoning in assessing data
            science technologies. Data Science students will complete coursework
            in math, coding (Python), statistics, ethics, and upper division
            electives of their choice.
          </p>

          <div className="core_areas_container">
            <h2>5 Core Areas</h2>
            <div className="cards">
              <ReactCardFlip
                flipDirection="horizontal"
                isFlipped={isFlipped1}
                className="card"
              >
                <div className="front" onClick={() => flipCard(1)}>
                  <div className="icon-container">
                    <MdComputer className="card-icon" size={40} />
                  </div>
                  <p className="card-text">
                    <strong>Introductory Coding</strong>
                  </p>
                  <div className="arrow-icon-container">
                    <GiRapidshareArrow
                      className="card-icon arrow-icon"
                      size={30}
                    />
                  </div>
                </div>

                <div className="front back" onClick={() => flipCard(1)}>
                  <p className="card-text">
                    <strong>
                      DS001 SC or CS004 PZ or MS056 SC or equivalent
                      introductory Python Course
                    </strong>
                  </p>
                  <div className="arrow-icon-container">
                    <GiRapidshareArrow
                      className="card-icon arrow-icon back-arrow"
                      size={30}
                    />
                  </div>
                </div>
              </ReactCardFlip>
              <ReactCardFlip
                flipDirection="horizontal"
                isFlipped={isFlipped2}
                className="card"
              >
                <div className="front" onClick={() => flipCard(2)}>
                  <div className="icon-container">
                    <TbDatabaseSearch className="card-icon" size={40} />
                  </div>
                  <p className="card-text">
                    <strong>Data Handling, Assessment, Enhancement</strong>
                  </p>
                  <div className="arrow-icon-container">
                    <GiRapidshareArrow
                      className="card-icon arrow-icon"
                      size={30}
                    />
                  </div>
                </div>

                <div className="front back" onClick={() => flipCard(2)}>
                  <p className="card-text">
                    <strong>DS002 SC</strong>
                  </p>
                  <div className="arrow-icon-container">
                    <GiRapidshareArrow
                      className="card-icon arrow-icon back-arrow"
                      size={30}
                    />
                  </div>
                </div>
              </ReactCardFlip>
              <ReactCardFlip
                flipDirection="horizontal"
                isFlipped={isFlipped3}
                className="card"
              >
                <div className="front" onClick={() => flipCard(3)}>
                  <div className="icon-container">
                    <img src={linalg} alt="" className="linalg-icon" />
                  </div>
                  <p className="card-text">
                    <strong>Linear Algebra</strong>
                  </p>
                  <div className="arrow-icon-container">
                    <GiRapidshareArrow
                      className="card-icon arrow-icon"
                      size={30}
                    />
                  </div>
                </div>

                <div className="front back" onClick={() => flipCard(3)}>
                  <p className="card-text">
                    <strong>
                      MATH060 SC or equivalent Linear Algebra course
                    </strong>
                  </p>
                  <div className="arrow-icon-container">
                    <GiRapidshareArrow
                      className="card-icon arrow-icon back-arrow"
                      size={30}
                    />
                  </div>
                </div>
              </ReactCardFlip>
              <ReactCardFlip
                flipDirection="horizontal"
                isFlipped={isFlipped4}
                className="card"
              >
                <div className="front" onClick={() => flipCard(4)}>
                  <div className="icon-container">
                    <ImStatsDots className="card-icon" size={40} />
                  </div>
                  <p className="card-text">
                    <strong>Applied Statistics</strong>
                  </p>
                  <div className="arrow-icon-container">
                    <GiRapidshareArrow
                      className="card-icon arrow-icon"
                      size={30}
                    />
                  </div>
                </div>

                <div className="front back" onClick={() => flipCard(4)}>
                  <p className="card-text">
                    <strong>
                      BIO174L KS or BIOL175 KS or ECON120 SC or PYSCH103 SC
                    </strong>
                  </p>
                  <div className="arrow-icon-container">
                    <GiRapidshareArrow
                      className="card-icon arrow-icon back-arrow"
                      size={30}
                    />
                  </div>
                </div>
              </ReactCardFlip>
              <ReactCardFlip
                flipDirection="horizontal"
                isFlipped={isFlipped5}
                className="card"
              >
                <div className="front" onClick={() => flipCard(5)}>
                  <div className="icon-container">
                    <PiScalesBold className="card-icon" size={40} />
                  </div>
                  <p className="card-text">
                    <strong>Data Science Ethics and Justice</strong>
                  </p>
                  <div className="arrow-icon-container">
                    <GiRapidshareArrow
                      className="card-icon arrow-icon"
                      size={30}
                    />
                  </div>
                </div>

                <div className="front back" onClick={() => flipCard(5)}>
                  <p className="card-text">
                    <strong>PSYC183 SC</strong>
                  </p>
                  <div className="arrow-icon-container">
                    <GiRapidshareArrow
                      className="card-icon arrow-icon back-arrow"
                      size={30}
                    />
                  </div>
                </div>
              </ReactCardFlip>
            </div>
          </div>
        </div>
      </div>
      <div className="decor-bar1">
        <h2 className="home-title1"> Why do a Data Science Minor?</h2>
      </div>
      <Quotes />
      <div className="space1" />
      <Footer />
    </div>
  );
}

export default Home;
